import React from "react";
import Collapsible from 'react-collapsible';
import ChevronIcon from '../assets/arrow.svg';

import "./Collapsible.scss";

const transitionTime = 200;

const CollapsibleComponent = ({title, children}) => {
  return (

    <Collapsible
      className="Question"
      openedClassName="Question QuestionOpen"
      trigger={
        <div className="layout horizontal center">
          {title}
          <div className="flex-auto" />
          <ChevronIcon className="ChevronIcon" />
        </div>
      }
      transitionTime={transitionTime}
    >
      { children }
    </Collapsible>
  );
}

export default CollapsibleComponent